import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { GoalService } from '@EYN/components';
import { Observable } from 'rxjs/internal/Observable';
import { first, map } from 'rxjs/operators';

@Injectable()
export class CanAccessPlanSummaryGuard implements CanActivate {
	constructor(private goalService: GoalService) {
	}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.goalService.withRouteConfig()
			.pipe(first(), map(([{ overviewRoute }, goal]) => {
				if (this.goalService.isGoalStarted(goal)) {
					return true;
				} else {
					this.goalService.goToOverviewPage();
					return false;
				}
			}));
	}
}
